import {connect} from "react-redux"
import {Dispatch} from "redux"

// Models
import {RootState} from "../../../models"
import {LeadData, Record} from "../models"

// Selectors
import {
    selectCommonParameters,
    selectLeadsData,
    selectParametersUpdating,
    selectRecordMetaData,
    selectRecordPatientInfo,
    selectParametersUpdated,
    selectParametersError,
    selectCurrentRecord,
    selectRecordConflict,
} from "../store/selectors"

// Actions
import {updateRecordParametersAsync} from "../store/actions"

/**
 */
const mapStateToProps = (state: RootState) => ({
    leadsData: selectLeadsData(state),
    metaData: selectRecordMetaData(state),
    patientInfo: selectRecordPatientInfo(state),
    commonParameters: selectCommonParameters(state),
    parametersUpdating: selectParametersUpdating(state),
    parametersUpdated: selectParametersUpdated(state),
    parametersError: selectParametersError(state),
    record: selectCurrentRecord(state),
    recordConflict: selectRecordConflict(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    updateParameters: (parameters: Record["commonParameters"]) => dispatch(updateRecordParametersAsync.request(parameters))
})

export type WithRecordDataProps = {
    leadsData: Array<LeadData>
    metaData: Record["metaData"]
    patientInfo: Record["patientInfo"]
    commonParameters: Record["commonParameters"]
    parametersUpdating: boolean
    parametersUpdated: boolean
    parametersError: string | null
    record: Record | null
    recordConflict: boolean
    updateParameters(parameters: Record["commonParameters"]): void
}

/**
 * @param BaseComponent
 */
export default (BaseComponent: any) => connect(mapStateToProps, mapDispatchToProps)(BaseComponent)
